"use client";

import { useState } from 'react';
import { useLocale } from 'next-intl';

export default function CertificationPage() {
  const locale = useLocale();
  const [certNo, setCertNo] = useState('');
  const [result, setResult] = useState<any>(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleQuery = async () => {
    if (!certNo.trim()) return;
    setLoading(true);
    setError('');
    setResult(null);

    try {
      const token = localStorage.getItem('token');
      const headers: any = {};
      if (token) headers['Authorization'] = `Bearer ${token}`;

      const res = await fetch(`/api/certificate/verify/${certNo.trim()}`, { headers });
      const text = await res.text();
      let data;
      try { data = JSON.parse(text); } catch(e) { data = {}; }

      if (res.ok) {
        setResult(data);
      } else {
        if (res.status === 401) {
          setError(locale === 'zh' ? '请先登录，防伪查验需要扣除查询算力积分' : 'Please login. Verification costs points.');
        } else if (res.status === 403) {
          setError(locale === 'zh' ? '账户可用积分不足，无法执行防伪溯源' : 'Insufficient points.');
        } else {
          setError(locale === 'zh' ? '未找到该编号对应的证书，请检查输入' : 'Certificate not found. Please check the number.');
        }
      }
    } catch (err) {
      setError(locale === 'zh' ? '网络错误，请稍后再试' : 'Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container" style={{ padding: '160px 20px 60px', minHeight: '60vh', maxWidth: '800px', margin: '0 auto' }}>
      <h1 style={{ color: 'var(--un-blue-dark)', marginBottom: '30px', textAlign: 'center' }}>
        {locale === 'zh' ? '世界非遗资质查询中心' : 'World Heritage Certification Query'}
      </h1>
      
      <div style={{ backgroundColor: '#fff', padding: '40px', border: '1px solid var(--border-color)', borderRadius: '8px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
        <p style={{ textAlign: 'center', color: '#666', marginBottom: '30px' }}>
          {locale === 'zh' ? '请输入完整的证书编号进行权威验真' : 'Please enter the complete certificate number for authoritative verification.'}
        </p>

        <div style={{ display: 'flex', gap: '10px', marginBottom: '30px', flexWrap: 'wrap' }}>
          <input 
            type="text" 
            value={certNo}
            onChange={(e) => setCertNo(e.target.value)}
            placeholder={locale === 'zh' ? '例如: WICH-2026-WORLD-0001' : 'e.g. WICH-2026-WORLD-0001'}
            style={{ flex: '1 1 250px', padding: '15px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '1rem', boxSizing: 'border-box' }} 
            onKeyDown={e => e.key === 'Enter' && handleQuery()}
          />
          <button 
            onClick={handleQuery}
            disabled={loading}
            style={{ padding: '15px 30px', flex: '1 1 120px', backgroundColor: 'var(--un-blue-dark)', color: 'white', border: 'none', borderRadius: '4px', fontSize: '1rem', cursor: loading ? 'not-allowed' : 'pointer', boxSizing: 'border-box' }}
          >
            {loading ? '...' : (locale === 'zh' ? '查询' : 'Query')}
          </button>
        </div>

        {error && <div style={{ color: '#d32f2f', textAlign: 'center', padding: '15px', backgroundColor: '#ffebee', borderRadius: '4px' }}>{error}</div>}

        {result && (
          <div style={{ marginTop: '30px', borderTop: '2px dashed #eee', paddingTop: '30px' }}>
             <h3 style={{ color: 'var(--un-gold)', textAlign: 'center', marginBottom: '20px' }}>
               {locale === 'zh' ? '查询结果：有效' : 'Query Result: VALID'}
             </h3>

             {result.certificate?.certImageUrl && (
               <div style={{ textAlign: 'center', marginBottom: '30px', padding: '20px', backgroundColor: '#fafafa', borderRadius: '8px' }}>
                 <h4 style={{ marginBottom: '15px', color: '#444' }}>
                   {locale === 'zh' ? '证书原件' : 'Certificate Image'}
                 </h4>
                 <img 
                   src={result.certificate.certImageUrl} 
                   alt="Certificate" 
                   style={{ maxWidth: '100%', maxHeight: '600px', borderRadius: '6px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' }} 
                 />
               </div>
             )}

             <table style={{ width: '100%', borderCollapse: 'collapse' }}>
               <tbody>
                 {[
                   { label: locale === 'zh' ? '证书编号' : 'Cert No', value: result.certificate?.certNo || certNo },
                   { label: locale === 'zh' ? '姓名/团体' : 'Name', value: result.inheritor || result.name },
                   { label: locale === 'zh' ? '非遗类别' : 'Category', value: result.category },
                   { label: locale === 'zh' ? '入库时间' : 'Recorded Date', value: new Date(result.inDbDate).toLocaleDateString() },
                   { label: locale === 'zh' ? '当前状态' : 'Status', value: result.certificate?.status === 'VALID' ? (locale==='zh'?'生效中':'Valid') : result.status },
                 ].map((row, idx) => (
                   <tr key={idx} style={{ borderBottom: '1px solid #eee' }}>
                     <td style={{ padding: '15px 10px', color: '#666', width: '30%' }}>{row.label}</td>
                     <td style={{ padding: '15px 10px', fontWeight: 'bold', color: 'var(--un-blue-dark)' }}>{row.value}</td>
                   </tr>
                 ))}
               </tbody>
             </table>
          </div>
        )}
      </div>
    </div>
  );
}
